/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FixedPriceContractDetailsResource
 */
export interface FixedPriceContractDetailsResource {
    /**
     * 
     * @type {Date}
     * @memberof FixedPriceContractDetailsResource
     */
    startDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceContractDetailsResource
     */
    totalAmountWithoutClientFeesExcludingTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceContractDetailsResource
     */
    totalAmountWithClientFeesExcludingTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceContractDetailsResource
     */
    totalAmountWithClientFeesIncludingTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceContractDetailsResource
     */
    serviceAmountIncludingTaxesForFreelancer?: number;
    /**
     * 
     * @type {number}
     * @memberof FixedPriceContractDetailsResource
     */
    serviceAmountIncludingTaxesForClient?: number;
}

/**
 * Check if a given object implements the FixedPriceContractDetailsResource interface.
 */
export function instanceOfFixedPriceContractDetailsResource(value: object): value is FixedPriceContractDetailsResource {
    return true;
}

export function FixedPriceContractDetailsResourceFromJSON(json: any): FixedPriceContractDetailsResource {
    return FixedPriceContractDetailsResourceFromJSONTyped(json, false);
}

export function FixedPriceContractDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceContractDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'totalAmountWithoutClientFeesExcludingTaxes': json['totalAmountWithoutClientFeesExcludingTaxes'] == null ? undefined : json['totalAmountWithoutClientFeesExcludingTaxes'],
        'totalAmountWithClientFeesExcludingTaxes': json['totalAmountWithClientFeesExcludingTaxes'] == null ? undefined : json['totalAmountWithClientFeesExcludingTaxes'],
        'totalAmountWithClientFeesIncludingTaxes': json['totalAmountWithClientFeesIncludingTaxes'] == null ? undefined : json['totalAmountWithClientFeesIncludingTaxes'],
        'serviceAmountIncludingTaxesForFreelancer': json['serviceAmountIncludingTaxesForFreelancer'] == null ? undefined : json['serviceAmountIncludingTaxesForFreelancer'],
        'serviceAmountIncludingTaxesForClient': json['serviceAmountIncludingTaxesForClient'] == null ? undefined : json['serviceAmountIncludingTaxesForClient'],
    };
}

export function FixedPriceContractDetailsResourceToJSON(value?: FixedPriceContractDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'totalAmountWithoutClientFeesExcludingTaxes': value['totalAmountWithoutClientFeesExcludingTaxes'],
        'totalAmountWithClientFeesExcludingTaxes': value['totalAmountWithClientFeesExcludingTaxes'],
        'totalAmountWithClientFeesIncludingTaxes': value['totalAmountWithClientFeesIncludingTaxes'],
        'serviceAmountIncludingTaxesForFreelancer': value['serviceAmountIncludingTaxesForFreelancer'],
        'serviceAmountIncludingTaxesForClient': value['serviceAmountIncludingTaxesForClient'],
    };
}

